import { Component } from '@angular/core';

@Component({
  selector: 'app-ngx-not-found',
  styleUrls: ['./not-found.component.scss'],
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {

  constructor() {
  }

}
